import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "px-6 py-3" }
const _hoisted_2 = {
  key: 0,
  class: ""
}
const _hoisted_3 = { class: "w-8/12 px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_4 = { class: "text-gray-500" }
const _hoisted_5 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_6 = { class: "px-6 py-5 text-sm text-gray-900 whitespace-nowrap" }
const _hoisted_7 = { class: "text-center whitespace-nowrap" }
const _hoisted_8 = { key: 1 }

import AdminLayout from '@/layouts/AdminLayout.vue';
import FilterComponent from '@/components/FilterComponent.vue';
import DataTable from '@/components/DataTable.vue';
import ActionButton from '@/components/ActionButton.vue';
import TabComponent from '@/components/TabComponent.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import PageLoader from '@/components/PageLoader.vue';
import PagePagination from '@/components/PagePagination.vue';
import ConfirmationModal from '@/components/modal/ConfirmationModal.vue';
import SuccessModal from '@/components/modal/SuccessModal.vue';
import ActivityLogsTable from '@/components/ActivityLogsTable.vue';

import throttle from "lodash/throttle";
import AdminData from '@/classes/AdminData';
import { useRouter } from 'vue-router';
import { paginatePage } from '@/helpers/PageHelper';
import { onMounted, ref, computed, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'IndexPage',
  setup(__props) {

const router = useRouter();
// Data
const loader           = ref(false);
const showError        = ref(false);
const errorMsg         = ref(null);
const seletected       = ref();
const showConfirmation  = ref(false);
const showSuccess      = ref(false);

const currentRoutePath = computed(() => router.currentRoute.value.path);
const getLoggedAdmin = computed(() => AdminData.getAdmin()) 

// Query
const searchText = ref();
const activeTab  = ref();
const goToPage   = ref();
const tab        = ref('all');
// Page Renderer Data
const items           = ref(null);
const items_count     = ref(null);
const rows            = ref(null);
const query           = ref(null);
const selected_tab    = ref('all');
const filterDate       = ref(null);
const log_event       = ref(null);
const log_query       = ref(null);
const log_date        = ref(null);
const active_count    = ref(0);
const archived_count  = ref(0);
const log_counts      = ref(0);
const logs            = ref({});
const log_event_lists = ref(null);


const tabs: { name: string, count: number, href: string, allowed: boolean }[] = computed(() => [
    {
        name: 'Active',
        count: active_count.value,
        href: "/accounts/admins",
        allowed: true
    },
    {
        name: 'Archived',
        count: archived_count.value,
        href: "/accounts/admins/archived",
        allowed: true
    },
    {
        name: 'Activity logs',
        count: log_counts.value,
        href: "/accounts/admins/logs",
        allowed:
            window.$hasPermission('view-activity-logs')
    }
]);

const headers: { text: string }[] = [
    { text: 'Admin' },
    { text: 'Role' },
    { text: 'Date Created'}
];

const applyFilters = () => {
    indexAdmins(goToPage.value)
}

const searchData = (val: string) => {
    searchText.value = val
}

/**
 * ********************************
 * Fetch Admin 
 * ********************************
 */
 const indexAdmins = async (data: string) => {
    try {
        loader.value = true;
        const queryString     = searchText.value ? `&query=${searchText.value}` : 'query';
        const dateQuery       = filterDate.value ? `&filterDate=${filterDate.value}` : '';
        const isArchivedRoute = currentRoutePath.value === '/accounts/admins/archived';
        const tabValue        = isArchivedRoute ? 'archived' : tab.value;
        const goToPageValue   = paginatePage(data);

        // const response = await AdminData.indexAdmin(`${goToPageValue}&tab=${tabValue}&${queryString}`);
        const response = await AdminData.indexAdmin(`${goToPageValue}&tab=${tabValue}&${queryString}&${dateQuery}`)
       
        loader.value          = false;
        items.value           = response?.data.items;
        items_count.value     = response?.data.items_count
        rows.value            = response?.data.rows
        query.value           = response?.data.query
        selected_tab.value    = response?.data.selected_tab
        log_event.value       = response?.data.log_event
        log_query.value       = response?.data.log_query
        log_date.value        = response?.data.log_date
        active_count.value    = response?.data.active_count
        archived_count.value  = response?.data.archived_count
        log_counts.value      = response?.data.log_counts
        logs.value            = response?.data.logs
        log_event_lists.value = response?.data.log_event_lists

    } catch(err) {
        loader.value    = false;
        showError.value = true;
        errorMsg.value  = err?.response?.data?.message;

        if (err?.response?.data?.status === 401) {
            window.location.replace('/login');
        }

    }
};

/**
 * ********************************
 * Archive Admin 
 * ********************************
 */
const selectedAdmin = (id: string) => {
    showConfirmation.value = true
    seletected.value = id
}

const archiveAdmin = async () => {
  try {
    loader.value = true;
    await AdminData.deleteAdmin(seletected.value);
    loader.value = false;
    window.location.replace('/accounts/admins/archived');
  } catch (err) {
    loader.value    = false;
    showError.value = true;
    errorMsg.value  = err?.response?.data.message;
  }
};

/**
 * ********************************
 * Restore Admin 
 * ********************************
 */

 const restoreAdmin = async (id: string) => {
  try {
    loader.value = true;
    await AdminData.restoreAdmin(id);
    loader.value = false;
    window.location.replace('/accounts/admins')
  } catch (err) {
    loader.value    = false;
    showError.value = true;
    errorMsg.value  = err?.response?.data.message;
  }
};

/**
 * ********************************
 * Export Admin 
 * ********************************
 */
 const exportData = async () => {
  try {
    loader.value = true;
    const params = currentRoutePath.value === '/accounts/admins/archived' ? { tab: 'archived' } : {};

    await AdminData.exportAdmin(params);
    showSuccess.value = true;
  } catch (error) {
    showError.value = true;
    errorMsg.value  = error.response?.data.message;
  } finally {
    loader.value = false;
  }
};

watch(
      searchText,
      throttle(() => {
        indexAdmins(goToPage.value)
      }, 1000)
    );

onMounted(() => indexAdmins(goToPage.value))


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AdminLayout, { title: "Admins" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(TabComponent, {
          tabs: tabs.value,
          "button-items": true
        }, {
          buttons: _withCtx(() => [
            _createVNode(ButtonComponent, {
              class: "text-gray-900",
              secondary: "",
              exportBtn: "",
              onClick: exportData,
              disabled: loader.value
            }, {
              default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                _createTextVNode(" Export ", -1)
              ]))]),
              _: 1
            }, 8, ["disabled"]),
            (_ctx.$hasPermission('create-admin-account') || _ctx.$hasPermission('register-for-an-account'))
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  createBtn: "",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push(`/accounts/admins/create`)))
                }, {
                  default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                    _createTextVNode(" Create ", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["tabs"])
      ]),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(FilterComponent, {
          search: searchText.value,
          onFetchData: searchData,
          "text-filters": currentRoutePath.value !== '/accounts/admins/logs',
          "onUpdate:filters": applyFilters,
          "custom-filters": activeTab.value !== 'activity_logs',
          "sidebar-filters": false
        }, null, 8, ["search", "text-filters", "custom-filters"])
      ]),
      (currentRoutePath.value !== '/accounts/admins/logs')
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(DataTable, {
              headers: headers,
              count: items.value?.total
            }, {
              body: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value?.data, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_3, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", null, _toDisplayString(item.name), 1),
                        _createElementVNode("p", _hoisted_4, _toDisplayString(item.email), 1)
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(item.roleName), 1),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(item.created_at), 1),
                    _createElementVNode("td", _hoisted_7, [
                      (_ctx.$hasPermission('update-admin-account') || _ctx.$hasPermission('register-for-an-account'))
                        ? (_openBlock(), _createBlock(ActionButton, {
                            key: 0,
                            "edit-btn": "",
                            onClick: ($event: any) => (_unref(router).push(`/accounts/admins/show/${item.id}`))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (getLoggedAdmin.value.id != item.id && !item.deleted_at && _ctx.$hasPermission('archive-admin-account'))
                        ? (_openBlock(), _createBlock(ActionButton, {
                            key: 1,
                            "delete-btn": "",
                            onClick: ($event: any) => (selectedAdmin(item.id))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (item.deleted_at && _ctx.$hasPermission('restore-admin-account'))
                        ? (_openBlock(), _createBlock(ActionButton, {
                            key: 2,
                            "restore-btn": "",
                            onClick: ($event: any) => (restoreAdmin(item.id))
                          }, null, 8, ["onClick"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["count"]),
            _createVNode(PagePagination, {
              class: "mb-6",
              items: items.value,
              onNextPage: indexAdmins
            }, null, 8, ["items"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(ActivityLogsTable, {
              logs: logs.value,
              onFetchIndex: indexAdmins
            }, null, 8, ["logs"])
          ])),
      (loader.value)
        ? (_openBlock(), _createBlock(PageLoader, { key: 2 }))
        : _createCommentVNode("", true),
      _createVNode(ConfirmationModal, {
        show: showConfirmation.value,
        onCancel: _cache[1] || (_cache[1] = ($event: any) => (showConfirmation.value = false)),
        onConfirm: _cache[2] || (_cache[2] = ($event: any) => {showConfirmation.value = false; archiveAdmin() }),
        "cancel-text": "Cancel",
        "action-text": "Confirm",
        title: "Archive Admin ?",
        content: "Are you sure you wish to archive this admin?"
      }, null, 8, ["show"]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onCancel: _cache[3] || (_cache[3] = ($event: any) => (showSuccess.value = false)),
        onConfirm: _cache[4] || (_cache[4] = ($event: any) => (showSuccess.value = false)),
        "action-text": "Close",
        title: "Admin Export",
        content: "Export is being processed. Please check your registered email."
      }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})